import Vue from 'vue';
import Router from 'vue-router';

import HomePage from '@/components/HomePage'
import RegisterPage from '@/components/RegisterPage'
import Login from '@/components/Login'

// Fallback page
import PageNotFound from "@/components/PageNotFound";

Vue.use(Router);

export const router = new Router({
    // mode: 'history',
    routes: [
        { path: '/', Name: "HomePage", component: HomePage },
        { path: '/register', Name: "RegisterPage", component: RegisterPage },
        { path: '/login', name: 'Login', component: Login },

        // Page not found MUST be the last one
        {path: '**', name: 'PageNotFound', component: PageNotFound }
    ]
});


router.beforeEach((to, from, next) => {

    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login', '/register'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');

    if (authRequired && !loggedIn) {
        return next('/login');
    }

    next();
})
